import { render, staticRenderFns } from "./ArticleDetail.vue?vue&type=template&id=598d9f4f&scoped=true"
import script from "./ArticleDetail.vue?vue&type=script&lang=js"
export * from "./ArticleDetail.vue?vue&type=script&lang=js"
import style0 from "./ArticleDetail.vue?vue&type=style&index=0&id=598d9f4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598d9f4f",
  null
  
)

export default component.exports